export default __webpack_public_path__ + "static/media/ArrowDown.a9534753.svg";